const routes = [
  {
    path: '/',
    component: () => import('@/view/page/index'),  
    meta: { title: '安亿仕' }
  },
  {
    path: '/store',
    component: () => import('@/view/store/store'),   //门店列表
    meta: { title: '门店列表' }
  },
  {
    path: '/category/list/:id',
    component: () => import('@/view/goods/category'),   //商品列表(分类)
    meta: { title: '商品列表' }
  },
  {
    path: '/goods/detail',
    component: () => import('@/view/goods/detail'),  //商品详情
    meta: { title: '商品详情' }
  },
  {
    path: '/article',
    component: () => import('@/view/article/index'),  //商品详情
    meta: { title: '文章列表' }
  },
  {
    path: '/page/index/:id',
    component: () => import('@/view/page/index'),  
    meta: { title: '安亿仕' }
  },
  {
    path: '/warranty/index',
    component: () => import('@/view/warranty/index'), 
    meta: { title: '质保查询' }
  },
  {
    path: '/warranty/detail',
    component: () => import('@/view/warranty/detail'), 
    meta: { title: '质保查询结果' }
  },
]

export default routes